import { Accordion } from 'honeydew/Accordion';
import useGlobalStore from 'hooks/useGlobalStore';

const generateLeadCapFaqList = ({ isMisfitsTheme }) => {
    const faqList = [
        {
            id: 1,
            headline: 'How does it work?',
            content: (
                <p>
                    Once you&apos;ve signed up, we&apos;ll assign you a shopping window and delivery day. Each week,
                    you&apos;ll be able to shop for your favorite proteins, produce, pantry items, snacks, and other
                    essentials while your shopping window&apos;s open. Then your order will arrive right at your front
                    door on your delivery day! You can skip an order, pause your subscription, or downgrade to our Flex
                    Plan at any time in your account.
                </p>
            ),
        },
        {
            id: 2,
            headline: 'Is there an order minimum?',
            content: (
                <p>
                    Yes, and it varies by delivery area. We&apos;ll start your cart with organic produce and
                    high-quality groceries every week that you can fully customize during your shopping window. Meet
                    your order minimum by the end of your shopping window and your items will be saved and you&apos;ll
                    automatically be charged—no checkout needed!
                </p>
            ),
        },
        {
            id: 3,
            headline: `What kind of products can I buy from ${isMisfitsTheme ? 'Misfits Market' : 'Imperfect Foods'}?`,
            content: (
                <p>
                    We offer a full lineup of delicious groceries including produce, animal and plant-based proteins,
                    dairy and eggs, pantry staples, beverages, snacks, and more. We also offer many exclusive items you
                    can only get through Misfits.
                </p>
            ),
        },
        {
            id: 4,
            headline: 'Why do I have to give my credit card to see what’s available?',
            content: (
                <p>
                    We&apos;re a subscription grocery delivery service, so it&apos;s important that we collect payment
                    details during signup. Our inventory is constantly changing, and sharing your credit card
                    information helps us accurately predict our inventory needs. Though we strive to keep grocery
                    staples in stock, we&apos;re unable to show you exactly what&apos;s available until the shopping
                    window for your upcoming order opens. But don&apos;t worry, you&apos;ll be able to fully edit your
                    order before you&apos;re charged!
                </p>
            ),
        },
    ];

    return faqList;
};

export default function LeadCapFAQS() {
    const { isMisfitsTheme } = useGlobalStore();

    return (
        <section className="w-full bg-white">
            <div className="mx-auto max-w-[820px] px-25 pb-[130px] pt-5 md:pb-[100px]">
                <h1 className="text-body-lg pt-20 font-grotesk-bold md:text-center">FAQs</h1>
                <Accordion items={generateLeadCapFaqList({ isMisfitsTheme })} />
            </div>
        </section>
    );
}
